// extracted by mini-css-extract-plugin
export default {"card":"style_card__wfhuK","shadow":"style_shadow__M6E3h","border":"style_border__MQDQ3"};